import { History } from 'history';

export const getRelativePath = (url: string): string => {
  try {
    const parsedUrl = new URL(url);

    return parsedUrl.pathname;
  } catch (e) {
    return url;
  }
};

export const goToUrl = (history: History, url: string) => {
  const relativeUrl = getRelativePath(url);

  if (relativeUrl) {
    history.push(relativeUrl);
  }
};
